/* The Mat Group - native multi-step configurator. Replaces Calconic (size/edging) + Hulk Product Options (options).
   Artwork stays with Upload-Lift. Flows: "logo" (variant or dimensions sizing) and "aam" (architectural, custom size).
   Variant-priced (logo) products use Option B: write into the theme product form + trigger native ATC so Upload-Lift submit hook fires.
   Custom-size pricing (AAM + area): TMG pricing service mints a one-off priced variant, then we add it via /cart/add.js directly (bypasses Calconic, no artwork needed). */
(function(){
  var MATP = window.__MAT_PRODUCT__ || {};
  var ROOT = document.getElementById('mat-configurator');
  if(!ROOT) return;

  if(!document.getElementById('mc-oos-style')){ var _oosSt=document.createElement('style'); _oosSt.id='mc-oos-style'; _oosSt.textContent='.mc-sw.mc-oos{opacity:.5} .mc-sw.mc-oos .chip{filter:grayscale(1)} .mc-oos-tag{color:#b00020;font-size:11px;font-weight:600} .mc-oos-note{margin:12px 0;padding:12px 14px;border:1px solid #e0b400;background:#fff8e1;border-radius:8px;font-size:14px;line-height:1.4;color:#5a4500}'; document.head.appendChild(_oosSt); }

  var SERVICE_URL = "https://tmg-custom-pricing2-production.up.railway.app";
  // Orientation diagram: portrait vs landscape. ARCHIMAT has no explicit orientation control, so the
  // diagram follows the dimensions the customer enters (width F-to-B > length L-to-R => portrait).
  var SIZE_DIAGRAM_L = MATP.diagramLandscape || "https://cdn.shopify.com/s/files/1/0565/5216/1447/files/67f703d20bd28d002a7f3b0c.webp?v=1780548665";
  var SIZE_DIAGRAM_P = MATP.diagramPortrait || SIZE_DIAGRAM_L;

  /* HubSpot quote-request form (same form as the universal enquiry box). Fields we prefill:
     name_of_product (text), mat_size (text), quantity (number) - the rest is the standard quote form. */
  var HS_QUOTE = { portalId:"8072856", formId:"954cb099-19e1-415d-9f09-f38c3fe7a434", region:"ap1", script:"https://js-ap1.hsforms.net/forms/embed/v2.js" };

  var SWATCHES = [
    {label:"Black",hex:"#1f1e1d"},{label:"Charcoal",hex:"#545250"},{label:"Evergreen",hex:"#0b4d05"},
    {label:"Bluestone",hex:"#76777a"},{label:"Cobalt Blue",hex:"#5f687a"},{label:"Blue",hex:"#5793cf"},
    {label:"Dark Brown",hex:"#4a2e0d"},{label:"Camel",hex:"#a3783b"},{label:"Sand",hex:"#a18467"},
    {label:"Granite Grey",hex:"#7a7e80"},{label:"Red/Black",hex:"#610808"}
  ];

  var ALU_COLOURS = [ {label:"Silver",hex:"#cfd2d4",sp:0}, {label:"Black",hex:"#1f1e1d",sp:1}, {label:"Bronze",hex:"#7b5a3a"} ];

  var SG_COLOURS = [
    {label:"Charcoal",hex:"#545250",sp:10},{label:"Black",hex:"#1f1e1d",sp:11},{label:"Mid Grey",hex:"#7a7e80",sp:12},{label:"Denim",hex:"#5f687a",sp:13},{label:"Sterling",hex:"#9aa0a6",sp:14},
    {label:"White",hex:"#f3f3f0",sp:15},{label:"Yellow",hex:"#e3c012",sp:16},{label:"Gold",hex:"#c79a26",sp:17},{label:"Orange",hex:"#d96a1f",sp:18},{label:"Bright Red",hex:"#c1272d",sp:19},
    {label:"Baby Blue",hex:"#8fc1e3",sp:20},{label:"Royal Blue",hex:"#2f5fbf",sp:21},{label:"Turquoise",hex:"#1fb6a6",sp:22},{label:"Kelly Green",hex:"#2e8b57",sp:23},{label:"American Green",hex:"#3a5f2e",sp:24},
    {label:"Pink",hex:"#e58fb0",sp:25},{label:"Purple",hex:"#6b3fa0",sp:26},{label:"Walnut",hex:"#5b3a1a",sp:27},{label:"Camel",hex:"#a3783b",sp:28},{label:"Natural Beige",hex:"#cbb994",sp:29}
  ];

  /* ORDER MATTERS: this is the order the fabric swatches render in (renderAAMStep "fabric").
     Merchandising order 2026-08-20 = Superguard, Coir, Superbrush, Ply, then the rest.
     Anything in AAM_OOS is pushed below the in-stock ones at render time, so this list only
     sets the running order - it does not need re-shuffling when stock comes back.
     NOTE sp = sprite tile index (mat-swatches.jpg), NOT a position in this array - never renumber it. */
  var AAM_FABRICS = [
    {name:"Superguard", sp:10, colours:SG_COLOURS},
    {name:"Coir", sp:6, colours:[{label:"Natural",hex:"#c2a271",sp:6},{label:"Black",hex:"#1f1e1d"}]},
    {name:"Superbrush", sp:9, colours:[]},
    {name:"Ply Insertion Rubber", sp:8, colours:[]},
    {name:"Granati", sp:2, colours:[{label:"Black",hex:"#1f1e1d",sp:2}]},
    {name:"Reno", sp:3, colours:[{label:"Black",hex:"#1f1e1d",sp:3}]},
    /* Metro REMOVED 2026-09-11: fails fire testing, discontinued (not restockable), see AAM_ACTIVE
       and AAM_BOARD below - all three must move together or the picker/board/validation disagree. */
    {name:"Hydrasorb", sp:7, colours:[]},
    {name:"Hydrasorb VG", sp:7, colours:[]}
  ];

  function getFabric(name){ for(var i=0;i<AAM_FABRICS.length;i++){ if(AAM_FABRICS[i].name===name) return AAM_FABRICS[i]; } return null; }

  /* ---- Real ARCHIMAT combination photography -------------------------------------------------
     window.__AAM_COMBO_IMG__ is injected by snippets/mat-configurator.liquid: it maps
     "<silver|black>|<insert-slug>" to the Shopify CDN url of that combination's flat, straight-on
     shot. It exists so a Denim swatch actually looks different on a Silver frame than on a Black
     one - the old sprite tile showed the insert only and was identical for both.
     Any combo missing from the map falls back to the sprite tile, so an unphotographed insert
     (e.g. Hydrasorb) still renders exactly as it does today. */
  var AAM_IMG = window.__AAM_COMBO_IMG__ || {};

  /* Fabric+colour -> the product slug used in the map. The generic slugify covers most of the
     range; SLUG_FIX carries the handful whose Shopify handle is not a straight slugify of the
     configurator's label.
     ⛔ "coir" -> "coir-natural" was REMOVED 2026-09-07. It existed only because Coir was declared
     colourless, and it made every Coir build resolve to the Natural product - including on the two
     Coir BLACK pages, which is how BAM-COIR-BLACK ended up unsellable and silver Coir Black
     ended up quoting SAM-COIR-NAT. Coir now carries its colours, so the plain slugify is correct.
     The half-chosen state ("Coir" picked, colour not yet) cannot reach the cart: validateAAM()
     line ~570 refuses to advance while a fabric with >1 colour has no colour selected. */
  var AAM_SLUG_FIX = { "superbrush":"super-brush" };
  function aamSlug(fabric, colour){
    if(!fabric) return "";
    var s = (fabric + (colour ? " " + colour : "")).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    return AAM_SLUG_FIX[s] || s;
  }
  function aamImgUrl(alu, fabric, colour, width){
    if(!alu || !fabric) return "";
    var u = AAM_IMG[alu.toLowerCase() + "|" + aamSlug(fabric, colour)];
    if(!u) return "";
    return width ? (u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + width) : u;
  }
  /* Picture to stand for a whole fabric before a colour is picked: the first colour of that fabric
     that is actually photographed on this frame. Walking the list (rather than hardcoding a default)
     means a fabric whose default colour was never shot still shows a real picture. */
  function aamFabricImg(alu, fabricName, width){
    var direct = aamImgUrl(alu, fabricName, "", width);
    if(direct) return direct;
    var f = getFabric(fabricName);
    if(f && f.colours) for(var i=0;i<f.colours.length;i++){
      var u = aamImgUrl(alu, fabricName, f.colours[i].label, width);
      if(u) return u;
    }
    return "";
  }
  /* Drive the theme's own product gallery rather than drawing a second preview inside the
     configurator: when the customer changes rail or insert, the main image on the left becomes that
     exact combination. Only the currently shown frame is touched, and only when the combination
     actually changes - so clicking a thumbnail still does what the theme normally does, because that
     does not re-render the configurator. */
  var lastGalleryUrl = null, gallerySynced = false;
  function syncGalleryImage(){
    if(cfg.flow!=="aam") return;
    var url = aamImgUrl(state.aluminium, state.fabric, state.fabricColour, 1200)
           || aamFabricImg(state.aluminium, state.fabric, 1200);
    if(!url) return;
    /* The first paint is the product's own combination, which is already the photo on screen. */
    if(!gallerySynced){ gallerySynced = true; lastGalleryUrl = url; return; }
    if(url === lastGalleryUrl) return;
    lastGalleryUrl = url;
    var viewer = document.querySelector('[data-gallery-viewer]');
    if(!viewer) return;
    var fig = viewer.querySelector('[data-gallery-figure][data-gallery-selected="true"]')
           || viewer.querySelector('[data-gallery-figure]');
    if(!fig) return;
    var img = fig.querySelector('img');
    if(!img) return;
    /* KEEP a [data-rimg] node here. empire.js's ProductClickToZoom.getThumbBoundsFn does an
       unguarded selectedSlide.querySelector('[data-rimg]').getBoundingClientRect(), so removing the
       attribute made click-to-zoom throw after every configuration change. Nothing rewrites src back:
       rimg.update() early-returns unless the node has data-rimg-template, which this img never has.
       Verified live - with this kept, the lightbox opens and the swapped src survives a resize. */
    img.setAttribute('data-rimg', '');
    img.removeAttribute('data-rimg-template');
    img.removeAttribute('data-rimg-template-svg');
    img.setAttribute('src', url);
    img.setAttribute('srcset', url + ' 1x');
    /* The alt still described the page's own product, so it contradicted both the photo and the
       heading the moment the customer changed anything. */
    var _altName = (typeof aamDisplayTitle === "function") ? aamDisplayTitle() : "";
    if(_altName) img.setAttribute('alt', 'Full product image of ' + String(_altName).replace(/\s*\|\s*/g, ' ').replace(/ Custom Size$/, '').trim());
    if(fig.hasAttribute('data-zoom')) fig.setAttribute('data-zoom', url);
  }

  /* GO-LIVE: only allow ARCHIMAT combos that are priced on the master "ARCHIMAT | Custom Size" product so
     customers can't add unpriced variations. Empty array = all colours of that fabric allowed (used for the
     genuinely colourless fabrics Superbrush/Ply). Add/remove rows as ranges get priced; AAM_RESTRICT=false opens all.
     ⛔⛔ An empty array is NOT a wildcard on the render path: renderAAMStep's colour picker filters
     f.colours against this list, so a fabric WITH colours must name them here or it renders zero
     chips and becomes unbuyable. That is why Coir is listed explicitly from 2026-09-07.
     NOTE: pricing + add-to-cart resolve to the master's real variants (the individual colour products stay DRAFT
     until their images are done) - see the tolerant matcher in findAAMVariant(). EOFY 2026: priced via compare-at. */
  var AAM_RESTRICT = true;
  var SG_ALL = SG_COLOURS.map(function(c){ return c.label; });
  var AAM_ACTIVE = {
    "Silver|Superguard":SG_ALL,            "Black|Superguard":SG_ALL,
    "Silver|Coir":["Natural","Black"],      "Black|Coir":["Natural","Black"],
    "Silver|Reno":["Black"],                "Black|Reno":["Black"],
    "Silver|Granati":["Black"],             "Black|Granati":["Black"],
    "Silver|Superbrush":[],                  "Black|Superbrush":[],
    "Silver|Ply Insertion Rubber":[],        "Black|Ply Insertion Rubber":[],
    /* Bronze 2026-10-22: only these five are made (CHAM-* SKUs). Metro has no fire cert in Archimat. */
    "Bronze|Superguard":["Black","Camel","Natural Beige"],
    "Bronze|Granati":["Black"],             "Bronze|Reno":["Black"]
  };
  function aamActiveFabrics(alu){ var o=[]; for(var k in AAM_ACTIVE){ var p=k.split("|"); if(p[0]===alu && o.indexOf(p[1])<0) o.push(p[1]); } return o; }
  function aamActiveColours(alu,fab){ return AAM_ACTIVE[alu+"|"+fab]||[]; }
  function aamComboActive(alu,fab,col){ var ac=AAM_ACTIVE[alu+"|"+fab]; if(!ac) return false; return ac.length?ac.indexOf(col)>-1:true; }

  /* TEMPORARILY OUT OF STOCK (2026-06): these inserts stay visible in the picker but are not buyable online.
     Selecting one shows an out-of-stock note and routes the customer to the existing "Request a custom size"
     enquiry form instead of Add to cart. To restock, remove the insert (or set AAM_OOS = {}). Keys = fabric names. */
  var AAM_OOS = {};
  function fabricOOS(f){ return !!(f && AAM_OOS[f]); }

  /* ARCHIMAT $/m2 rate = the matched combo variant's live price (single source: Shopify variant prices).
     A sale on the variant (price < compareAt) flows straight through; aamFullRate() feeds the strikethrough. */
  function aamRate(){ var av=findAAMVariant(); return (av && parseFloat(av.price)>0) ? parseFloat(av.price) : 0; }
  function aamFullRate(){ var av=findAAMVariant(); if(!av) return 0; var ca=parseFloat(av.compareAt)||0, p=parseFloat(av.price)||0; return (ca>p&&p>0)?ca:0; }

  var MAT_CONFIG = {
    "high-def-printed-mat": {
      title:"High Def Printed Logo Mat",
      steps:["size","options","review"],
      sizeMode:"variant",
      pricing:{type:"variant"},
      options:[
        {key:"Mat Colour",type:"swatch",label:"Mat colour",choices:SWATCHES,required:true},
        {key:"Logo Colours",type:"multiswatch",label:"Logo colours (select all used)",choices:SWATCHES,required:true},
        {key:"Orientation",type:"dropdown",label:"Orientation",choices:["Landscape","Portrait"],required:true},
        {key:"Floor Type",type:"dropdown",label:"Floor type",choices:["Carpet","Hard floor","Outdoor / rough"],required:true},
        {key:"_artwork_note",type:"info",label:"Upload your logo/artwork in the file-upload field on this page (vector EPS, AI or PDF preferred). Handled by Upload-Lift."}
      ],
      properties:{}
    },
    "superguard-heavy-duty-matting": {
      title:"Superguard Heavy Duty Matting (Custom Size)",
      steps:["size","review"],
      sizeMode:"dimensions",
      pricing:{type:"area",edgingRatePerM:30},
      size:{lengthLabel:"Length (L to R)",lengthMin:500,lengthMax:20000,widthLabel:"Width (F to B)",widthMin:500,widthMax:2000,unit:"mm"},
      edging:{propertyName:"Edging",options:[{label:"Yes",rate:30},{label:"No",rate:0}],default:"Yes"},
      properties:{length:"Length (mm)",width:"Width (mm)"}
    }
  };

  /* ARCHIMAT (AAM) products - defaults keyed by current product handle.
     NOTE: at go-live these handles change to the new archimat-* slugs; update the keys below to match. */
  var AAM_SIZE = {lengthLabel:"Length (L to R)",lengthMin:500,lengthMax:1800,widthLabel:"Width (F to B)",widthMin:500,widthMax:2500,unit:"mm"};
  function aamConfig(defaults){
    return {
      title:"ARCHIMAT",
      flow:"aam",
      /* Always the full flow. A colour-specific page still opens on its own rail and insert
         (see defaults below) but the customer can change either without leaving the product. */
      /* Always the full flow. A colour page still opens on its own rail and insert (defaults below)
         but the customer can change either - and findAAMVariant() now follows them to the right
         product's SKU and rate. */
      steps: ["size","aluminium","fabric","review"],
      size:AAM_SIZE,
      recess:{label:"Recess depth (optional)",min:0,max:100,default:0,step:5},
      aluminium:{label:"Choose your colour",choices:ALU_COLOURS},
      defaults:defaults || null,
      lockToReview: false,
      sizeDiagramL:SIZE_DIAGRAM_L,
      sizeDiagramP:SIZE_DIAGRAM_P,
      pricing:{type:"area"}
    };
  }
  var AAM_DEFAULTS = {
    "aluminium-architectural-matting-charcoal":{aluminium:"Silver",fabric:"Superguard",fabricColour:"Charcoal"},
    "aluminium-architectural-matting-black":{aluminium:"Silver",fabric:"Superguard",fabricColour:"Black"},
    "aluminium-architectural-matting-denim":{aluminium:"Silver",fabric:"Superguard",fabricColour:"Denim"},
    "aluminium-architectural-matting-camel":{aluminium:"Silver",fabric:"Superguard",fabricColour:"Camel"},
    "aluminium-architectural-matting-mid-grey-insert-clear-aluminum-custom-size":{aluminium:"Silver",fabric:"Superguard",fabricColour:"Mid Grey"},
    "aluminium-architectural-matting-walnut-insert-clear-aluminium-custom-size":{aluminium:"Silver",fabric:"Superguard",fabricColour:"Walnut"},
    "aluminium-architectural-matting-coir-insert-clear-aluminium-custom-size":{aluminium:"Silver",fabric:"Coir",fabricColour:"Natural"},
    "aluminium-architectural-matting-ply-rubber-clear-aluminium-custom-size":{aluminium:"Silver",fabric:"Ply Insertion Rubber",fabricColour:""},
    "aluminium-architectural-matting-black-insert-black-aluminium-custom-size":{aluminium:"Black",fabric:"Superguard",fabricColour:"Black"},
    "aluminium-architectural-matting-charcoal-insert-black-aluminum-custom-size":{aluminium:"Black",fabric:"Superguard",fabricColour:"Charcoal"},
    "aluminium-architectural-matting-custom-size":null
  };
  Object.keys(AAM_DEFAULTS).forEach(function(h){ MAT_CONFIG[h]=aamConfig(AAM_DEFAULTS[h]); });

  /* Handle-agnostic ARCHIMAT detection. Any product whose handle/title says ARCHIMAT gets the AAM
     configurator, regardless of its handle (products were renamed to silver-/black-archimat-* slugs).
     Defaults (aluminium + fabric + colour) are parsed from the product name so colour-specific pages
     skip to size->review; if they can't be read (e.g. the generic master) it falls back to the full flow. */
  function archimatLike(p){
    var h=(p.handle||"").toLowerCase(), t=(p.title||"").toLowerCase();
    return h.indexOf("archimat")>-1 || t.indexOf("archimat")>-1 || h.indexOf("aluminium-architectural-matting")>-1;
  }
  function parseAAMFrom(norm){
    var FABS=[["hydrasorb vg","Hydrasorb VG"],["hydrasorb","Hydrasorb"],["ply insertion rubber","Ply Insertion Rubber"],["super brush","Superbrush"],["superbrush","Superbrush"],["superguard","Superguard"],["granati","Granati"],["reno","Reno"],["metro","Metro"],["coir","Coir"]];
    var fabric="", tail="";
    for(var i=0;i<FABS.length;i++){ var idx=norm.indexOf(FABS[i][0]); if(idx>-1){ fabric=FABS[i][1]; tail=norm.slice(idx+FABS[i][0].length); break; } }
    if(!fabric) return null; // generic master / unreadable -> full pick-everything flow
    var alu="Silver";
    if(/bronze archimat/.test(norm) || /bronze aluminium/.test(norm)) alu="Bronze";
    else if(/black archimat/.test(norm) || /black aluminium/.test(norm)) alu="Black";
    else if(/silver archimat/.test(norm) || /silver aluminium/.test(norm)) alu="Silver";
    var fobj=getFabric(fabric), colour="";
    if(fobj && fobj.colours.length){
      for(var c=0;c<fobj.colours.length;c++){ if(tail.indexOf(fobj.colours[c].label.toLowerCase())>-1){ colour=fobj.colours[c].label; break; } }
      if(!colour && fobj.colours.length===1) colour=fobj.colours[0].label;
      if(!colour && fobj.colours.length>1) return null; // colour required but unreadable -> let the customer pick
    }
    return {aluminium:alu, fabric:fabric, fabricColour:colour};
  }
  function parseAAMDefaults(p){
    // Parse from the handle first (reliable, consistent slugs); fall back to the title. Never concatenate the two
    // (it lets the aluminium "black" leak into the fabric-colour read, or matches "black archimat" across the join).
    return parseAAMFrom((p.handle||"").toLowerCase().replace(/-/g," "))
        || parseAAMFrom((p.title||"").toLowerCase().replace(/\|/g," ").replace(/-/g," "));
  }

  var STEP_TITLES = {size:"Size", aluminium:"Aluminium", fabric:"Fabric", options:"Options", review:"Review"};

  var cfg = MAT_CONFIG[MATP.handle] || (archimatLike(MATP) ? aamConfig(parseAAMDefaults(MATP)) : null);
  if(!cfg){ ROOT.style.display='none'; return; }

  var variants = MATP.variants || [];

  var state = {
    stepIndex:0, qty:1,
    size:{length:"",width:""},
    variantId:null, variantTitle:"", variantPrice:0,
    edgingRate: cfg.edging ? cfg.edging.options.filter(function(o){return o.label===cfg.edging.default;})[0].rate : 0,
    edgingLabel: cfg.edging ? cfg.edging.default : null,
    options:{},
    recessDepth:0, aluminium:"", fabric:"", fabricColour:"", colourOpen:false, comments:""
  };
  if(cfg.flow==="aam"){
    var baseV = variants.filter(function(v){return /custom/i.test(v.title);})[0] || variants[0];
    state.recessDepth = (cfg.recess && cfg.recess.default) || 0;
    state.aluminium = (cfg.defaults && cfg.defaults.aluminium) || "";
    state.fabric = (cfg.defaults && cfg.defaults.fabric) || "";
    state.fabricColour = (cfg.defaults && cfg.defaults.fabricColour) || "";
    state.variantId = baseV ? baseV.id : null;
    state.variantTitle = baseV ? baseV.title : "";
    state.variantPrice = baseV ? baseV.price : 0;
  }

  function step(){ return cfg.steps[state.stepIndex]; }
  function money(n){ return "$"+(Math.round(n*100)/100).toFixed(2); }
  function ppsqm(){ return parseFloat(MATP.pricePerSqm)||0; }
  function esc(s){ return String(s).replace(/"/g,'&quot;'); }
  function esc2(s){ return String(s||"").replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  // ARCHIMAT now uses the product's REAL variant (real SKU + set price) - no Railway minting, no CFG variants.
  // Canonical keys for tolerant master matching (master variant titles use inconsistent word order).
  function aamFabKey(s){ s=String(s||"").toLowerCase();
    if(s.indexOf("superguard")>-1) return "superguard";
    if(s.indexOf("granati")>-1) return "granati";
    if(s.indexOf("reno")>-1) return "reno";
    if(s.indexOf("metro")>-1) return "metro";
    if(s.indexOf("coir")>-1) return "coir";
    if(s.indexOf("ply")>-1) return "ply";
    if(s.indexOf("super brush")>-1 || s.indexOf("superbrush")>-1) return "superbrush";
    if(s.indexOf("hydrasorb")>-1) return "hydrasorb";
    return ""; }
  function aamColKey(s){ return String(s||"").toLowerCase()
    .replace(/superguard|granati|reno|metro|coir|ply insertion rubber|ply rubber|ply|super brush|superbrush|hydrasorb( vg| fr)?|insertion|rubber/g,"")
    .replace(/\s+/g," ").trim(); }
  /* Real sellable variant per frame+insert combination, injected by snippets/mat-configurator.liquid.
     Keys are "<silver|black>|<insert-slug>"; each value carries the product handle, variant id, SKU and
     $/m2 of the product that IS that combination. Generated by archimat-images/build-combo-variant-map.js
     from live Shopify data. */
  var AAM_VAR = window.__AAM_COMBO_VARIANT__ || {};
  function aamComboVariant(){
    if(!state.aluminium || !state.fabric) return null;
    var v = AAM_VAR[state.aluminium.toLowerCase() + "|" + aamSlug(state.fabric, state.fabricColour)];
    if(!v) return null;
    /* Shape it like a theme variant object so every caller (aamRate, aamFullRate, addToCart) is unchanged. */
    return { id:v.id, title:v.title, price:v.price, compareAt:v.compareAt, sku:v.sku, handle:v.handle, available:true };
  }

  /* ---- Page identity follows the combination the customer actually built ----------------------
     Every ARCHIMAT colourway is its own Shopify product with its own title, SKU and $/m2. The
     configurator lets any colourway page build any combination, and addToCart already mints on
     THAT product's handle, so the cart line, the SKU and the rate the customer pays are all the
     built combination's. The page headings were the only thing left still naming the URL's
     product - change fabric on the Denim page and the h1 still said "Denim".

     THE RULE - the displayed name is a pure function of state, never of click history:
       the page's own server-rendered title    if the built key == the key this page loaded with
       else the combination product's title    if that combination resolves to the product we
                                               will actually mint on
       else the page's own title               (unmapped or half-chosen state)
     Being a pure function is what makes "customer came back to this page's own combination", the
     first paint and the half-chosen states all converge instead of drifting apart.

     Title source is aamComboVariant() ONLY. findAAMVariant()'s first branch matches the MASTER
     product's own variants, whose titles are "Charcoal Superguard / Silver" - a VARIANT title, not
     a product name. The av.handle === cv.handle test below is what keeps the heading honest: on the
     master, step 1 wins and returns a variant with NO handle, so the mint falls back to the master
     (mintHandle = av.handle || MATP.handle) and the cart line will NOT name the combination - so we
     leave the master's heading alone rather than promise a name the cart will not show.

     Turn any single surface off here without touching the logic below. */
  var AAM_SYNC = { title:true, breadcrumb:true, sku:true, fromPrice:true, quoteForm:true, rangeBoard:true };
  var pageTitle = null, pageSku = null, pageFromPrice = null, initialComboKey = null;
  var lastIdentityTitle = null, announcer = null;

  function tidy(s){ return String(s==null?"":s).replace(/\s+/g," ").trim(); }
  function aamComboKey(){ return String(state.aluminium||"").toLowerCase()+"|"+aamSlug(state.fabric, state.fabricColour); }

  /* Re-queried on every call, never cached: empire.js _moveForm() detaches and re-appends
     [data-product-form-area] on breakpoint crossings, and quickshop injects a SECOND
     [data-product-details] (carrying an h2.product-title) OUTSIDE [data-product-wrapper].
     h1 plus the [data-product-wrapper] scope is what excludes that modal, the recommendation and
     recently-viewed grids (they use .productitem--title), the header search flydown
     (.search-flydown--product-title) and the add-to-cart banner (.atc-banner--product-title). */
  function productTitleEl(){
    return document.querySelector('[data-product-wrapper] [data-product-details] h1.product-title')
        || document.querySelector('.product--outer .product-details h1.product-title')
        || document.querySelector('h1.product-title');  /* the exact selector injectSiblings() already uses in production */
  }
  function productSkuEl(){
    return document.querySelector('[data-product-wrapper] [data-product-details] [data-product-sku]')
        || document.querySelector('[data-product-sku]');
  }
  function fromPriceEl(){
    return document.querySelector('[data-product-wrapper] [data-tmg-fromline] .money')
        || document.querySelector('[data-tmg-fromline] .money');
  }
  /* Breadcrumb leaf: the last element child that is not a delimiter, and only ever a bare SPAN -
     never the "Home" link. It sits ~40px above the h1, so leaving it frozen would put two different
     product names on the same screen. The machine-readable BreadcrumbList JSON-LD is NOT touched:
     its @id is the canonical url, so location stays pinned to the URL and only the human-readable
     product name follows the build. */
  function breadcrumbLeafEl(){
    var nav = document.querySelector('.breadcrumbs-container'); if(!nav) return null;
    var kids = nav.children, last = null;
    for(var i=0;i<kids.length;i++){ if(String(kids[i].className||"").indexOf('breadcrumbs-delimiter')<0) last = kids[i]; }
    return (last && last.tagName === 'SPAN') ? last : null;
  }

  /* Called ONCE, before the first render(), so every later call is a pure state->string map. */
  function captureProductIdentity(){
    if(cfg.flow!=="aam") return;
    var h=productTitleEl(), sk=productSkuEl(), fp=fromPriceEl();
    pageTitle = tidy(MATP.title) || (h ? tidy(h.textContent) : "");
    pageSku   = sk ? tidy(sk.textContent) : "";
    pageFromPrice = fp ? tidy(fp.textContent) : "";
    initialComboKey = aamComboKey();
    lastIdentityTitle = pageTitle;
  }

  /* The combination product we will actually mint on, or null. Null covers: half-chosen states
     (picking "Superguard" clears the colour, so the key is "silver|superguard" and is not in the
     map), Hydrasorb (no map rows at all), and the master product (step 1 wins, so there is no handle). */
  function aamIdentityVariant(){
    var cv = aamComboVariant(); if(!cv || !cv.title) return null;
    var av = findAAMVariant();
    if(!av || !av.handle || av.handle !== cv.handle) return null;
    return cv;
  }
  function aamDisplayTitle(){
    if(cfg.flow!=="aam") return MATP.title||"";
    var base = pageTitle || MATP.title || "";
    /* This URL's own combination -> the server-rendered heading, verbatim. This is also what
       protects the two Coir Black products, whose own key resolves through AAM_SLUG_FIX to
       "<frame>|coir-natural" and would otherwise relabel their page "Coir | Natural". */
    if(initialComboKey!==null && aamComboKey()===initialComboKey) return base;
    var v = aamIdentityVariant();
    return v ? v.title : base;
  }

  /* In B2B mode the configurator is display:none'd and the visible identity must stay pinned to
     #tmg-b2b-product, which is the enquiry/quote payload - never rename anything there. */
  function identityOff(){ return cfg.flow!=="aam" || !!window.tmgB2B; }

  function syncProductIdentity(){
    if(identityOff() || !AAM_SYNC.title) return;
    var next = aamDisplayTitle();
    if(!next) return;                                   /* never blank a heading */
    var el = productTitleEl();
    /* Nothing writes INSIDE this heading today - the BSS Product Labels badge (jQuery .after())
       and the B2B sibling pills (insertAdjacentElement 'afterend') are both SIBLINGS, which is why
       textContent is safe here. If an app ever does inject markup into it, hand the node back
       untouched rather than delete their element. */
    if(el && !el.children.length && tidy(el.textContent) !== next){
      el.textContent = next;                            /* textContent, never innerHTML/outerHTML */
      announceTitle(next);
    }
    if(AAM_SYNC.breadcrumb){
      var bc = breadcrumbLeafEl(), cur = bc ? tidy(bc.textContent) : "";
      /* Only ever rewrite a leaf that is still showing a name we put there (or the page's own).
         If a collection crumb is ever added, or the snippet changes shape, this switches itself off. */
      if(bc && !bc.children.length && cur !== next && (cur === pageTitle || cur === lastIdentityTitle)){
        bc.textContent = next;
      }
    }
    lastIdentityTitle = next;
  }

  /* Once the heading follows the build, a SKU line 90px below it still reading SAM-SG-DENIM is a
     contradiction the heading itself created - so this ships with it, not after it. Trade buyers
     copy this SKU straight onto a purchase order.
     Guards: never write "" (the PDP's own fallback script re-asserts its baked SKU through a
     MutationObserver the instant this span goes empty), and skip the one map row that has no SKU
     (silver|coir-black). */
  function syncProductSku(){
    if(identityOff() || !AAM_SYNC.sku) return;
    var el = productSkuEl(); if(!el || el.children.length) return;
    var next = pageSku;
    if(initialComboKey!==null && aamComboKey()!==initialComboKey){
      var v = aamIdentityVariant();
      if(v){ if(!tidy(v.sku)) return; next = tidy(v.sku); }
    }
    if(!next) return;
    if(tidy(el.textContent) === next) return;
    el.textContent = next;
  }

  /* The "$616/m2" line under the title is deliberately NOT class "price", so hideThemeControls()
     leaves it visible where it hides the theme's other price nodes. There are three real rates in
     the range (616 / 638 / 660), so once the heading names a Black product this line would sit
     beside it still quoting the Silver rate - two different rates for one mat on one screen. It
     shows the same number aamRate() already charges; it decides nothing. */
  function syncFromPrice(){
    if(identityOff() || !AAM_SYNC.fromPrice) return;
    var el = fromPriceEl(); if(!el || el.children.length) return;
    var next = pageFromPrice;
    if(initialComboKey!==null && aamComboKey()!==initialComboKey){
      var v = aamIdentityVariant();
      if(v){ var p = parseFloat(v.price); if(!(p>0)) return; next = "$" + String(Math.round(p)); }
    }
    if(!next) return;
    if(tidy(el.textContent) === next) return;
    el.textContent = next;
  }

  /* Screen readers: the h1 must NOT carry aria-live (it re-announces as a heading), and a live
     region inside ROOT is destroyed by ROOT.innerHTML on every render, so it would never announce
     reliably. One persistent polite region on body, created the first time the name changes.
     Pipes are read out as "vertical bar" by some AT, so they become commas. */
  function announceTitle(t){
    try{
      if(!announcer){
        announcer = document.createElement('span');
        announcer.setAttribute('aria-live','polite');
        announcer.setAttribute('aria-atomic','true');
        announcer.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
        document.body.appendChild(announcer);
      }
      announcer.textContent = 'Now configuring ' + String(t).replace(/\s*\|\s*/g, ', ');
    }catch(e){}
  }

  function findAAMVariant(){
    /* 1. The master product carries one variant per "<insert> / <aluminium>" combo - match those first
          so its behaviour is exactly as before. */
    if(state.fabric && state.aluminium){ // master: one variant per Insert(colour+fabric)/Aluminium combo
      var alu=String(state.aluminium).toLowerCase();
      var insert = ((state.fabricColour?state.fabricColour+" ":"")+state.fabric).trim().toLowerCase();
      var i, p;
      for(i=0;i<variants.length;i++){
        p=String(variants[i].title).split(" / ");
        if(p.length>=2 && p[1].trim().toLowerCase()===alu && p[0].trim().toLowerCase()===insert) return variants[i];
      }
      // tolerant fallback: "Granati Black" vs "Charcoal Superguard" vs "Superguard White" - match on canonical fabric+colour keys
      var wantFab=aamFabKey(state.fabric), wantCol=String(state.fabricColour||"").toLowerCase().trim();
      for(i=0;i<variants.length;i++){
        p=String(variants[i].title).split(" / ");
        if(p.length<2 || p[1].trim().toLowerCase()!==alu) continue;
        if(aamFabKey(p[0])!==wantFab) continue;
        if(wantCol==="" || aamColKey(p[0])===wantCol) return variants[i];
      }
    }
    /* 2. Otherwise resolve the SELECTED combination to the product that is that combination. This is
          what stops a colour page selling its own SKU and rate for someone else's combination. */
    var mapped = aamComboVariant();
    if(mapped) return mapped;
    /* 3. Deliberately NO "just use this product's Custom Size variant" fallback: silently selling the
          wrong SKU at the wrong price is worse than telling the customer to ask for a quote. */
    return null;
  }
  function tmgEmitUnit(u,suf){ try{ document.dispatchEvent(new CustomEvent('tmg:unitprice',{detail:{unit:(u>0?u:0),suffix:(u>0&&suf)?suf:''}})); }catch(e){} } /* 14 Oct 2026: tell the page header the configured price */
  function computePrice(){
    if(cfg.flow==="aam"){
      var av=findAAMVariant();
      if(!av) return 0; var _L=parseFloat(state.size.length)||0, _W=parseFloat(state.size.width)||0; if(!_L||!_W) return 0; return aamRate()*(_L*_W)/1000000;
    }
    if(cfg.pricing.type==="variant") return state.variantPrice||0;
    if(cfg.pricing.type==="area"){
      var L=parseFloat(state.size.length)||0, W=parseFloat(state.size.width)||0;
      if(!L||!W) return 0;
      return ppsqm()*(L*W)/1000000 + state.edgingRate*(2*L+2*W)/1000;
    }
    return 0;
  }

  function validate(){
    if(cfg.flow==="aam") return validateAAM();
    var s=step(), e=[];
    if(s==="size"){
      if(cfg.sizeMode==="variant"){ if(!state.variantId) e.push("choose a size"); }
      else {
        var L=parseFloat(state.size.length), W=parseFloat(state.size.width), z=cfg.size;
        if(!L||L<z.lengthMin||L>z.lengthMax) e.push("length "+z.lengthMin+"-"+z.lengthMax+z.unit);
        if(!W||W<z.widthMin||W>z.widthMax) e.push("width "+z.widthMin+"-"+z.widthMax+z.unit);
      }
    }
    if(s==="options"&&cfg.options){
      cfg.options.forEach(function(o){
        if(o.type==="info"||!o.required) return;
        var v=state.options[o.key];
        if(o.type==="multiswatch"){ if(!v||!v.length) e.push(o.label+": pick one"); }
        else if(!v) e.push(o.label+" required");
      });
    }
    return e;
  }
  function validateAAM(){
    // Range is NOT enforced here - out-of-range is caught by aamOutOfRange() -> custom-size popup (in the
    // nav handler, on every step incl. review). Here we only require the dimensions to be entered, with a
    // plain message (no ranges, no "Fix:").
    var s=step(), e=[];
    if(s==="size"){
      var L=parseFloat(state.size.length), W=parseFloat(state.size.width);
      if(!(L>0) || !(W>0)) e.push("Enter your mat dimensions");
    }
    if(s==="aluminium"){ if(!state.aluminium) e.push("choose an aluminium colour"); }
    if(s==="fabric"){
      if(!state.fabric) e.push("choose a fabric");
      else if(!fabricOOS(state.fabric)){ var f=getFabric(state.fabric); if(f && f.colours.length>1 && !state.fabricColour) e.push("choose a fabric colour"); }
    }
    if(s==="review"){
      var L2=parseFloat(state.size.length), W2=parseFloat(state.size.width);
      if(!(L2>0) || !(W2>0)) e.push("Enter your mat dimensions");
      if(!state.aluminium) e.push("choose an aluminium colour");
      if(!state.fabric) e.push("choose a fabric");
      else if(!fabricOOS(state.fabric)){ var f2=getFabric(state.fabric); if(f2 && f2.colours.length>1 && !state.fabricColour) e.push("choose a fabric colour"); }
      if(AAM_RESTRICT && state.fabric && !fabricOOS(state.fabric) && !aamComboActive(state.aluminium, state.fabric, state.fabricColour)) e.push("that combination isn't available online yet");
    }
    return e;
  }

  function buildPayload(){
    if(cfg.flow==="aam") return payloadAAM();
    var props={};
    if(cfg.sizeMode==="dimensions" && cfg.steps.indexOf("size")>-1){
      props[cfg.properties.length]=state.size.length+" "+cfg.size.unit;
      props[cfg.properties.width]=state.size.width+" "+cfg.size.unit;
      if(cfg.edging) props[cfg.edging.propertyName]=state.edgingLabel;
    }
    if(cfg.options) cfg.options.forEach(function(o){
      if(o.type==="info") return;
      var v=state.options[o.key];
      if(v) props[o.key]=Array.isArray(v)?v.join(", "):v;
    });
    return {properties:props,_computed_price:Math.round(computePrice()*100)/100,variantId:state.variantId};
  }
  function payloadAAM(){
    var props={}, z=cfg.size;
    if(state.size.length) props[z.lengthLabel+" ("+z.unit+")"]=state.size.length;
    if(state.size.width) props[z.widthLabel+" ("+z.unit+")"]=state.size.width;
    if(state.recessDepth>0) props["Recess Depth (mm)"]=String(state.recessDepth);
    if(state.aluminium) props["Aluminium Colour"]=state.aluminium;
    if(state.fabric) props["Fabric"]=state.fabric;
    if(state.fabricColour) props["Fabric Colour"]=state.fabricColour;
    if(state.comments) props["Comments"]=state.comments;
    return {properties:props,_computed_price:Math.round(computePrice()*100)/100,variantId:state.variantId};
  }

  function setErr(msg){ var el=ROOT.querySelector('#mc-err'); if(el){ el.textContent=msg; el.classList.add('show'); } }

  /* Progress bar: render() rebuilds ROOT.innerHTML wholesale, so a fresh .mc-progf has no
     previous computed width and its transition cannot fire. Paint it at the PREVIOUS percentage,
     then set the new one next frame so it glides like the other three configurators. */
  var _mcProgPct = null;
  function render(){
    var s=step();
    var _mcPct = Math.round(((state.stepIndex+1)/cfg.steps.length)*100);
    var _mcFrom = (_mcProgPct===null) ? _mcPct : _mcProgPct;
    var stepsHtml = cfg.steps.map(function(st,i){
      var c=i===state.stepIndex?"active":(i<state.stepIndex?"done":"");
      return '<div class="s '+c+'" data-go="'+i+'"><span class="n">'+(i+1)+'</span>'+STEP_TITLES[st]+'</div>';
    }).join("");
    var body = (cfg.flow==="aam") ? renderAAMStep(s) : (s==="size"?renderSize():s==="options"?renderOptions():renderReview());
    var p=computePrice(); tmgEmitUnit(p);
    var sub = cfg.pricing.type==="area" ? ' <small>incl. edging - estimate</small>' : ' <small>'+(state.variantTitle||"")+'</small>';
    var priceHtml = (cfg.flow==="aam") ? '' : ((p>0 && s!=="review") ? '<div class="mc-price">'+money(p)+sub+'</div>' : '');
    ROOT.innerHTML =
      '<div class="mc-head"><h3>Configure your mat</h3><div class="mc-sub">'+esc2(aamDisplayTitle())+'</div></div>'+
      '<div class="mc-body">'+
        '<div class="mc-steps">'+stepsHtml+'</div>'+
        '<div class="mc-prog" aria-hidden="true"><span class="mc-progf" style="width:'+_mcFrom+'%"></span></div>'+
        '<div class="mc-step">'+body+'</div>'+priceHtml+
        '<div class="mc-nav">'+
          '<button type="button" class="mc-btn ghost" data-act="back" style="visibility:'+(state.stepIndex===0?"hidden":"visible")+'">&lsaquo; Back</button>'+
          '<button type="button" class="mc-btn primary" data-act="next">'+(s==="review"?(cfg.flow==="aam"&&fabricOOS(state.fabric)?"Request a custom size":"Add to cart"):(cfg.flow==="aam"&&s==="size"&&aamOutOfRange()?"Request a custom size":"Next &rsaquo;"))+'</button>'+
        '</div>'+
      '</div>';
    wire(s);
    (function(){ var _f=ROOT.querySelector('.mc-progf');
      if(_f && _mcFrom!==_mcPct){ void _f.offsetWidth; _f.style.width=_mcPct+'%'; }
      _mcProgPct=_mcPct; })();
    syncGalleryImage();
    try{ syncProductIdentity(); syncProductSku(); syncFromPrice(); aamBoardBuild(); aamBoardMark(); }catch(e){}
  }

  function renderSize(){
    if(cfg.sizeMode==="variant"){
      var opts='<option value="">Select a size...</option>'+variants.map(function(v){
        var dis=v.available===false;
        return '<option value="'+v.id+'" '+(state.variantId===v.id?"selected":"")+(dis?" disabled":"")+'>'+v.title+' - '+money(v.price)+(dis?" (sold out)":"")+'</option>';
      }).join("");
      return '<div class="mc-field"><label>Choose your size</label><select id="mc-variant-select">'+opts+'</select></div>'+mcQtyHTML()+'<div class="mc-err" id="mc-err"></div>';
    }
    var z=cfg.size,e=cfg.edging;
    var html='<div class="mc-field"><label>Enter your size</label><div class="mc-dims">'+
      '<div class="d"><label>'+z.lengthLabel+' ('+z.unit+')</label><input type="number" id="mc-len" min="'+z.lengthMin+'" max="'+z.lengthMax+'" value="'+state.size.length+'" placeholder="'+z.lengthMin+'-'+z.lengthMax+'"></div>'+
      '<div class="d"><label>'+z.widthLabel+' ('+z.unit+')</label><input type="number" id="mc-wid" min="'+z.widthMin+'" max="'+z.widthMax+'" value="'+state.size.width+'" placeholder="'+z.widthMin+'-'+z.widthMax+'"></div>'+
      '</div><div class="mc-hint">Length '+z.lengthMin+'-'+z.lengthMax+z.unit+', width '+z.widthMin+'-'+z.widthMax+z.unit+'.</div></div>';
    if(e){
      html+='<div class="mc-field"><label>'+e.propertyName+'? <span class="mc-hint" style="font-weight:400">(+$'+e.options[0].rate+'/linear m)</span></label><div class="mc-radios" id="mc-edging">'+
        e.options.map(function(o){return '<label><input type="radio" name="mc-edging" value="'+o.label+'" data-rate="'+o.rate+'" '+(o.label===state.edgingLabel?"checked":"")+'> '+o.label+'</label>';}).join("")+
        '</div></div>';
    }
    return html+mcQtyHTML()+'<div class="mc-err" id="mc-err"></div>';
  }

  function mcQtyHTML(){ return '<div class="mc-field"><label>Quantity</label><div class="mc-qty"><button type="button" data-mcqty="-1">\u2212</button><input type="number" id="mc-qty" min="1" step="1" value="'+(state.qty||1)+'"><button type="button" data-mcqty="1">+</button></div></div>'; }

  function renderOptions(){
    return cfg.options.map(function(o){
      if(o.type==="info") return '<div class="mc-field"><div class="mc-info">'+o.label+'</div></div>';
      var inner="";
      if(o.type==="swatch"||o.type==="multiswatch"){
        inner=swatchGroup(o.key, o.choices, state.options[o.key]||(o.type==="multiswatch"?[]:null), o.type==="multiswatch");
      } else if(o.type==="dropdown"){
        inner='<select data-key="'+o.key+'"><option value="">Select...</option>'+
          o.choices.map(function(ch){return '<option '+(state.options[o.key]===ch?"selected":"")+'>'+ch+'</option>';}).join("")+'</select>';
      } else if(o.type==="radio"){
        inner='<div class="mc-radios" data-key="'+o.key+'">'+
          o.choices.map(function(ch){return '<label><input type="radio" name="'+o.key+'" value="'+esc(ch)+'" '+(state.options[o.key]===ch?"checked":"")+'> '+ch+'</label>';}).join("")+'</div>';
      }
      return '<div class="mc-field"><label>'+o.label+(o.required?" *":"")+'</label>'+inner+'</div>';
    }).join("")+'<div class="mc-err" id="mc-err"></div>';
  }

  function renderReview(){
    var pl=buildPayload(), rowsArr=[];
    if(cfg.sizeMode==="variant" && state.variantTitle) rowsArr.push(["Size",state.variantTitle]);
    Object.keys(pl.properties).forEach(function(k){ rowsArr.push([k,pl.properties[k]]); });
    var rows=rowsArr.map(function(kv){ var v=kv[1]; if(String(v).length>60)v=String(v).slice(0,60)+"."; return '<div class="row"><span class="k">'+kv[0]+'</span><span>'+v+'</span></div>'; }).join("");
    if(!rows) rows='<div class="row"><span class="k">No options</span><span>-</span></div>';
    var note = cfg.pricing.type==="area" ? 'final price - set at checkout' : 'price';
    return '<div class="mc-summary">'+rows+'</div><div class="mc-price">'+money(pl._computed_price)+' <small>'+note+'. Add artwork via the upload field on this page.</small></div><div class="mc-err" id="mc-err"></div>';
  }

  function swatchGroup(key, choices, selected, multi){
    var sprite = window.__MAT_SPRITE__;
    return '<div class="mc-sw-wrap" data-key="'+key+'" data-multi="'+(!!multi)+'">'+choices.map(function(ch){
      var on = multi ? (selected||[]).indexOf(ch.label)>-1 : selected===ch.label;
      var chipStyle;
      /* A real photo of THIS frame+insert combination wins over the sprite: the sprite tile shows the
         insert alone, so Silver and Black frames were previously indistinguishable in the picker. */
      if(ch.img){ chipStyle='background-image:url('+ch.img+');background-size:cover'; }
      else if(sprite && ch.sp!=null){ var col=ch.sp%6, row=Math.floor(ch.sp/6); chipStyle='background-image:url('+sprite+');background-size:600% 500%;background-position:'+(col*20)+'% '+(row*25)+'%'; }
      else { chipStyle='background:'+ch.hex; }
      var oosCls = ch.oos ? " mc-oos" : "";
      var oosLab = ch.oos ? '<span class="mc-oos-tag"> (out of stock)</span>' : '';
      return '<div class="mc-sw'+(on?" sel":"")+oosCls+'" data-val="'+esc(ch.label)+'"><div class="chip" style="'+chipStyle+'"></div><span class="lab">'+ch.label+oosLab+'</span></div>';
    }).join("")+'</div>';
  }
  function aamPriceLine(){ if(fabricOOS(state.fabric)) return ''; var p=computePrice(); return '<div class="mc-price" id="mc-price">'+(p>0?money(p):'-')+'</div>'; }
  function aamOosNote(){ if(!fabricOOS(state.fabric)) return ''; return '<div class="mc-oos-note"><strong>'+esc2(state.fabric)+' is temporarily out of stock.</strong> You can still request it - click "Request a custom size" below and we\'ll get back to you with a quote.</div>'; }
  function renderAAMStep(s){
    var z=cfg.size;
    if(s==="size"){
      var diagram = cfg.sizeDiagramL ? '<img class="mc-sizediagram" src="'+aamDiagramSrc()+'" alt="How to measure your mat - '+aamOrient()+' orientation, length L to R, width F to B">' : '';
      return '<div class="mc-cols"><div class="mc-cola">'+diagram+'</div><div class="mc-colb">'+
        '<div class="mc-field"><label>Enter your size</label><div class="mc-dims">'+
        '<div class="d"><label>'+z.lengthLabel+' ('+z.unit+')</label><input type="number" id="mc-len" value="'+state.size.length+'" placeholder="Enter length"></div>'+
        '<div class="d"><label>'+z.widthLabel+' ('+z.unit+')</label><input type="number" id="mc-wid" value="'+state.size.width+'" placeholder="Enter width"></div>'+
        '</div></div>'+
        '<div class="mc-err" id="mc-err"></div>'+
        '</div></div>';
    }
    if(s==="aluminium"){
      /* Show each frame carrying the insert already chosen (or a representative one), so the choice
         between Silver and Black is made on the actual mat rather than on two metal swatches. */
      var aluChoices = cfg.aluminium.choices.map(function(c){
        var u = aamImgUrl(c.label, state.fabric, state.fabricColour, 240) || aamFabricImg(c.label, state.fabric || "Superguard", 240);
        return u ? {label:c.label, hex:c.hex, sp:c.sp, img:u} : c;
      });
      return '<div class="mc-field"><label>'+cfg.aluminium.label+'</label>'+swatchGroup("aluminium", aluChoices, state.aluminium, false)+'</div>'+aamPriceLine()+'<div class="mc-err" id="mc-err"></div>';
    }
    if(s==="fabric"){
      var fabChoices=AAM_FABRICS.map(function(f){return {label:f.name, sp:f.sp, hex:"#999", oos:fabricOOS(f.name), img:aamFabricImg(state.aluminium, f.name, 240)};});
      if(AAM_RESTRICT){ var af=aamActiveFabrics(state.aluminium); fabChoices=fabChoices.filter(function(c){ return af.indexOf(c.label)>-1; }); }
      // in-stock first (in AAM_FABRICS order), out-of-stock last - stable partition, no sort()
      fabChoices = fabChoices.filter(function(c){ return !c.oos; }).concat(fabChoices.filter(function(c){ return c.oos; }));
      var html='<div class="mc-field"><label>Choose your fabric</label>'+swatchGroup("fabric", fabChoices, state.fabric, false)+'</div>';
      var f=getFabric(state.fabric);
      var fcols = f ? f.colours : [];
      if(f && AAM_RESTRICT){ var ac=aamActiveColours(state.aluminium, state.fabric); fcols=f.colours.filter(function(c){ return ac.indexOf(c.label)>-1; }); }
      if(f && fcols.length>1 && !fabricOOS(state.fabric)){
        if(state.fabricColour && !state.colourOpen){
          html+='<div class="mc-field"><div style="display:flex;align-items:center;justify-content:space-between;gap:12px;border:1px solid #e3e3e3;border-radius:8px;padding:10px 14px;font-size:14px">Colour: <strong>'+state.fabricColour+'</strong><button type="button" class="mc-btn" data-cd-changecol style="font-size:13px;padding:6px 12px">Change colour</button></div></div>';
        } else {
          var colChoices=fcols.map(function(c){
            var u=aamImgUrl(state.aluminium, state.fabric, c.label, 240);
            return u ? {label:c.label, hex:c.hex, sp:c.sp, img:u} : c;
          });
          html+='<div class="mc-field"><label>Choose your colour</label>'+swatchGroup("fabricColour", colChoices, state.fabricColour, false)+'</div>';
        }
      }
      return html+aamOosNote()+aamPriceLine()+'<div class="mc-err" id="mc-err"></div>';
    }
    var pl=buildPayload(), rowsArr=[];
    Object.keys(pl.properties).forEach(function(k){ if(k!=="Comments") rowsArr.push([k,pl.properties[k]]); });
    var rows=rowsArr.map(function(kv){ return '<div class="row"><span class="k">'+kv[0]+'</span><span>'+kv[1]+'</span></div>'; }).join("");
    if(!rows) rows='<div class="row"><span class="k">Configure above</span><span>-</span></div>';
    var _aamL=parseFloat(state.size.length)||0,_aamW=parseFloat(state.size.width)||0,_aamFull=aamFullRate()*(_aamL*_aamW)/1000000,_aamNow=computePrice(); var priceOrNote = fabricOOS(state.fabric) ? aamOosNote() : '<div class="mc-price">'+money(_aamNow)+((_aamFull>_aamNow&&_aamNow>0)?(' <small><s style="opacity:.55">'+money(_aamFull)+'</s> &middot; '+Math.round((1-_aamNow/_aamFull)*100)+'% off</small>'):'')+'</div>';
    return '<div class="mc-summary">'+rows+'</div>'+
      '<div class="mc-field"><label>Comments (optional)</label><textarea id="mc-comments" rows="3" placeholder="Anything we should know?" style="width:100%;box-sizing:border-box">'+esc2(state.comments)+'</textarea></div>'+
      priceOrNote+'<div class="mc-err" id="mc-err"></div>';
  }

  /* The single place a frame / insert / colour choice is applied. Extracted from the swatch click
     handler so the range board tiles run byte-identical logic - a tile can never build a combination
     the picker itself could not, which is what keeps findAAMVariant() honest. */
  function applyAAMChoice(key, val){
    if(key==="aluminium"){
      state.aluminium=val;
      if(AAM_RESTRICT){
        if(aamActiveFabrics(val).indexOf(state.fabric)<0) state.fabric="";
        if(state.fabricColour && !aamComboActive(val, state.fabric, state.fabricColour)) state.fabricColour="";
      }
    }
    else if(key==="fabricColour"){ state.fabricColour=val; state.colourOpen=false; }
    else if(key==="fabric"){ state.fabric=val; var f=getFabric(val); state.fabricColour = (f&&f.colours.length===1)?f.colours[0].label:""; state.colourOpen=false; }
  }

  /* ---- The ARCHIMAT range board ----------------------------------------------------------------
     Zac 2026-09-01: the additional images under the main photo should be one FIXED collection of the
     ARCHIMAT range, identical on every ARCHIMAT page, so they never go stale as the customer
     configures. 14 tiles = 2 frames x 7 inserts, one representative photo each, all confirmed
     present in window.__AAM_COMBO_IMG__.

     The board REPLACES the theme's own thumbnail disclosure, because a per-product strip is exactly
     the thing that went stale. The product's own extra photos are still reachable: clicking the main
     image opens the theme lightbox with every figure (which is why the data-rimg fix in
     syncGalleryImage() is a prerequisite for this, not a nice-to-have).

     Deliberately NOT built like a theme thumbnail:
       - no [data-gallery-thumbnail] / [data-gallery-index] / [data-media] - empire.js snapshots
         this.thumbnails and this.figures at init and maps PhotoSwipe indices off them, so a fake
         thumbnail would point at a figure that does not exist;
       - never inside [data-gallery-scroller] or [data-gallery-viewer] - both carry delegated
         click handlers;
       - no data-rimg* of any kind - rimg.init() has already run by the time this builds, so a lazy
         node would be watched by nobody and stay blank forever. Plain img + explicit ?width. */
  var AAM_BOARD_ID = "aam-range-board";
  var AAM_BOARD = [
    { fab:"Superguard",           key:"superguard-charcoal"   },
    { fab:"Coir",                 key:"coir-natural"          },
    { fab:"Superbrush",           key:"super-brush"           },
    { fab:"Ply Insertion Rubber", key:"ply-insertion-rubber"  },
    { fab:"Granati",              key:"granati-black"         },
    { fab:"Reno",                 key:"reno-black"            }
  ];

  function aamBoardStyle(){
    if(document.getElementById("aam-range-board-css")) return;
    var st=document.createElement("style"); st.id="aam-range-board-css";
    /* The gallery column is only ~243-338px wide on a cfg-page (mat-configurator.css sets
       .product-gallery to 25%), so this is a wrapping grid, not the theme's horizontal scroller.
       The fixed aspect box reserves layout height before the images decode, so the [data-cfgfit]
       rAF in product.liquid measures a settled DOM. */
    st.textContent =
      '.aam-board{margin-top:12px}'+
      '.aam-board[hidden]{display:none!important}'+
      '.aam-board-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(92px,1fr));gap:8px}'+
      '.aam-board-tile{display:block;width:100%;padding:0;border:1px solid #e3e3e3;border-radius:8px;'+
        'background:#fff;cursor:pointer;overflow:hidden;text-align:left;font:inherit;color:inherit}'+
      '.aam-board-tile:hover{border-color:#bdbdbd}'+
      '.aam-board-tile:focus-visible{outline:2px solid #f05322;outline-offset:2px}'+
      '.aam-board-tile[aria-current="true"]{border-color:#f05322;box-shadow:0 0 0 1px #f05322 inset}'+
      '.aam-board-tile .pic{display:block;width:100%;padding-top:62.5%;position:relative;background:#f4f4f4}'+
      '.aam-board-tile .pic img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block}'+
      '.aam-board-tile .cap{display:block;padding:5px 6px 6px;font-size:11px;line-height:1.25;color:#3c3c3c}'+
      '.aam-board-tile .cap b{display:block;font-weight:600}'+
      '.aam-board-oos{color:#b00020;font-size:10px}';
    document.head.appendChild(st);
  }

  /* One row -> the state a click should produce. Colour is deliberately NOT taken from the tile key:
     it is defaulted by applyAAMChoice() exactly as a real fabric swatch click would, so a tile can
     never build a combination the picker itself could not. */
  /* Always through a ?width= transform: the originals are full-size CDN files and 14 of them raw is
     megabytes for tiles rendered under 120px. Same idiom as aamImgUrl(). */
  function aamBoardImg(alu, row){
    var u = aamImgUrl(alu, row.fab, "", 240);
    if(u) return u;
    u = AAM_IMG[alu.toLowerCase()+"|"+row.key];
    if(u) return u + (u.indexOf("?")>-1 ? "&" : "?") + "width=240";
    /* Bronze has no Charcoal: show the first colour of that fabric photographed on this frame. */
    return aamFabricImg(alu, row.fab, 240);
  }
  function aamBoardTileHTML(alu, row){
    var url = aamBoardImg(alu, row);
    if(!url) return "";
    var on = (state.aluminium===alu && state.fabric===row.fab);
    var oos = fabricOOS(row.fab) ? '<span class="aam-board-oos">out of stock</span>' : '';
    return '<button type="button" class="aam-board-tile" data-aam-alu="'+esc(alu)+'" data-aam-fab="'+esc(row.fab)+'"'+
             (on?' aria-current="true"':'')+'>'+
             '<span class="pic"><img src="'+esc(url)+'" alt="'+esc(alu+" ARCHIMAT with "+row.fab+" insert")+'" loading="lazy" decoding="async"></span>'+
             '<span class="cap"><b>'+esc2(alu)+'</b>'+esc2(row.fab)+' '+oos+'</span>'+
           '</button>';
  }

  /* Built once, and guarded on DOM PRESENCE rather than a boolean: in the theme editor a
     shopify:section:load replaces the gallery DOM and destroys the board, and a boolean would say
     "already done" forever. The board lives outside #mat-configurator, so ROOT.innerHTML does not
     wipe it - which is exactly why it must not be rebuilt on every render(). */
  function aamBoardBuild(){
    if(cfg.flow!=="aam" || !AAM_SYNC.rangeBoard || window.tmgB2B) return;
    var gal = document.querySelector('[data-product-gallery]'); if(!gal) return;
    /* With thumbnails on the left the theme renders [data-gallery-navigation] as its own column and
       empire.js measures it to size that column; hiding it there would break the layout. */
    if(gal.getAttribute('data-product-gallery-thumbnails')==='left') return;
    if(document.getElementById(AAM_BOARD_ID)) return;

    var tiles="", tileCount=0;
    for(var a=0;a<ALU_COLOURS.length;a++){
      for(var i=0;i<AAM_BOARD.length;i++){ var th=aamBoardTileHTML(ALU_COLOURS[a].label, AAM_BOARD[i]); if(th){ tiles+=th; tileCount++; } }
    }
    if(!tiles) return;                       /* no photography resolved - leave the theme strip alone */
    aamBoardStyle();

    var wrap=document.createElement('div'); wrap.className='pg-more-wrap aam-board-wrap';
    var chev = gal.querySelector('.pg-more-toggle__chev');
    wrap.innerHTML =
      '<button type="button" class="pg-more-toggle" data-aam-board-toggle aria-expanded="false" aria-controls="'+AAM_BOARD_ID+'">'+
        '<span class="pg-more-toggle__label">See the full ARCHIMAT range</span>'+
        '<span class="pg-more-toggle__count">('+tileCount+')</span>'+
        '<span class="pg-more-toggle__chev" aria-hidden="true">'+(chev?chev.innerHTML:'')+'</span>'+
      '</button>'+
      '<div class="pg-more aam-board" id="'+AAM_BOARD_ID+'" hidden><div class="aam-board-grid">'+tiles+'</div></div>';
    gal.appendChild(wrap);

    /* Hide, never remove: empire.js holds live references to the navigation and its thumbnails
       (this.thumbnails is snapshotted at init and feeds PhotoSwipe's thumb-bounds mapping). */
    var themeWrap = gal.querySelector('.pg-more-wrap:not(.aam-board-wrap)');
    if(themeWrap) themeWrap.style.display='none';
    var nav = gal.querySelector(':scope > [data-gallery-navigation]');
    if(nav) nav.style.display='none';

    /* Property assignment, matching the file's idiom, so handlers can never accumulate. */
    var btn = wrap.querySelector('[data-aam-board-toggle]');
    var panel = wrap.querySelector('#'+AAM_BOARD_ID);
    btn.onclick = function(){
      var open = btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded', open?'false':'true');
      panel.hidden = open;
      btn.querySelector('.pg-more-toggle__label').textContent = open ? 'See the full ARCHIMAT range' : 'Hide the ARCHIMAT range';
      if(!open) window.dispatchEvent(new Event('resize'));
    };
    panel.onclick = function(e){
      var tile = e.target.closest ? e.target.closest('.aam-board-tile') : null;
      if(!tile) return;
      applyAAMChoice('aluminium', tile.getAttribute('data-aam-alu'));
      applyAAMChoice('fabric', tile.getAttribute('data-aam-fab'));
      var fi = cfg.steps.indexOf('fabric'); if(fi>-1) state.stepIndex = fi;
      render();
    };
  }

  /* Keeps the tile outline on whatever is currently configured. Cheap, and the only per-render work
     the board does. */
  function aamBoardMark(){
    var panel = document.getElementById(AAM_BOARD_ID); if(!panel) return;
    var tiles = panel.querySelectorAll('.aam-board-tile');
    for(var i=0;i<tiles.length;i++){
      var on = tiles[i].getAttribute('data-aam-alu')===state.aluminium && tiles[i].getAttribute('data-aam-fab')===state.fabric;
      if(on) tiles[i].setAttribute('aria-current','true'); else tiles[i].removeAttribute('aria-current');
    }
  }

  function getForm(){ var fs=document.querySelectorAll('form[data-product-form]'); for(var i=0;i<fs.length;i++){ if(fs[i].querySelector('[data-product-atc]')) return fs[i]; } return fs[0]||null; }
  function setFormVariant(form,id){ var el=form.querySelector('[name=id]'); if(el){ try{ el.value=id; el.dispatchEvent(new Event('change',{bubbles:true})); }catch(err){} } else { var inp=document.createElement('input'); inp.type='hidden'; inp.name='id'; inp.value=id; inp.setAttribute('data-mc-prop',''); form.appendChild(inp); } }
  function setFormQty(form,q){ var el=form.querySelector('[name=quantity]'); if(el){ try{ el.value=q; el.dispatchEvent(new Event('change',{bubbles:true})); }catch(err){} } else { var inp=document.createElement('input'); inp.type='hidden'; inp.name='quantity'; inp.value=q; inp.setAttribute('data-mc-prop',''); form.appendChild(inp); } }
  function writeProps(form,props){ Array.prototype.forEach.call(form.querySelectorAll('[data-mc-prop]'),function(n){ if(n.name!=='id') n.remove(); }); Object.keys(props).forEach(function(k){ var inp=document.createElement('input'); inp.type='hidden'; inp.name='properties['+k+']'; inp.value=props[k]; inp.setAttribute('data-mc-prop',''); form.appendChild(inp); }); }
  function placeConfigurator(){ var form=getForm(); if(!form||!ROOT) return; try{ form.insertBefore(ROOT, form.firstChild); }catch(e){ try{ form.parentNode.insertBefore(ROOT, form); }catch(e2){} } }
  function hideThemeControls(){
    var form=getForm(); if(!form) return;
    if(cfg.sizeMode==="variant" || cfg.flow==="aam" || cfg.pricing.type==="area"){ var vu=form.querySelector('[data-variants-ui]'); if(vu){ vu.style.display='none'; } }
    var atc=form.querySelector('[data-product-atc]'); if(atc){ var wrap=atc.closest('.product-form--atc')||atc; wrap.style.display='none'; }
    var pb=form.querySelector('.shopify-payment-button'); if(pb){ pb.style.display='none'; }
    try{ var _pw=document.querySelector('[data-product-wrapper]')||document.querySelector('.product--container'); if(_pw){ Array.prototype.forEach.call(_pw.querySelectorAll('.price'),function(_el){ _el.style.display='none'; }); } }catch(e){}
  }

  function needsServerPrice(){ return cfg.flow==="aam" || (cfg.pricing && cfg.pricing.type==="area"); }

  /* Wait until the minted variant is FULLY live on the STOREFRONT (price>0 AND sku), cache-busted; resolves false if never ready so the caller ABORTS (no $0 / blank-SKU line). */
  function waitForSku(handle, vid){
    return new Promise(function(resolve){ var tries=0, MAX=24; function cb(){ try{ return Date.now(); }catch(e){ return tries; } } (function poll(){ tries++;
      fetch("/products/"+handle+".js?_cb="+vid+"-"+tries+"-"+cb(),{cache:"no-store"}).then(function(r){return r.json();}).then(function(p){
        var v=(p.variants||[]).filter(function(x){return String(x.id)===String(vid);})[0];
        if(v && v.sku && Number(v.price)>0){ resolve(true); } else if(tries>=MAX){ resolve(false); } else setTimeout(poll,500);
      }).catch(function(){ if(tries>=MAX) resolve(false); else setTimeout(poll,500); }); })(); });
  }
  function addToCart(btn){
    var pl=buildPayload(), props={};
    Object.keys(pl.properties).forEach(function(k){ props[k]=pl.properties[k]; });

    if(cfg.flow==="aam"){
      if(fabricOOS(state.fabric)){ openCustomSizeModal(); return; }
      // Mint a faithful CLONE of the chosen combo variant (same price + same SKU) that ALSO carries a
      // size-scaled shipping weight, then add it. The shared master variant can't hold a per-order weight,
      // so this is the only way to make ARCHIMAT freight accurate. Pricing + Cin7 stay unchanged.
      var av=findAAMVariant();
      if(!av || !av.id){ setErr("that combination isn't available online yet - please request a quote"); return; }
      btn.disabled=true; btn.textContent="Pricing...";
      /* av.handle is set when the combination lives on another product; the pricing service looks the
         variant up ON that handle and mints there, so the cart line inherits that product's title
         ("Black ARCHIMAT | Superguard | Natural Beige | Custom Size") and its SKU. */
      var mintHandle = av.handle || MATP.handle;
      var aamBody={ handle:mintHandle, lengthMm:parseFloat(state.size.length)||0, widthMm:parseFloat(state.size.width)||0, edging:(state.edgingLabel||"No"), fabric:(state.fabric||""), aluminium:(state.aluminium||""), variantId:String(av.id).split("/").pop() };
      fetch(SERVICE_URL+"/custom-variant", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(aamBody) })
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
        .then(function(res){
          if(!res.ok || !res.j || !res.j.variantId){ throw new Error((res.j&&res.j.error)?(typeof res.j.error==="string"?res.j.error:JSON.stringify(res.j.error)):"pricing failed"); }
          btn.textContent="Adding...";
          return waitForSku(mintHandle, res.j.variantId).then(function(ok){ if(!ok) throw new Error('VARIANT_NOT_READY'); return fetch("/cart/add.js", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ id:res.j.variantId, quantity:Math.max(1,state.qty||1), properties:props }) }); });
        })
        .then(function(r){ if(!r) return; if(!r.ok){ return r.json().then(function(j){ throw new Error(j.description||j.message||"add to cart failed"); }); } window.location.href="/cart"; })
        .catch(function(err){ btn.disabled=false; btn.textContent="Add to cart"; setErr((err&&err.message==='VARIANT_NOT_READY') ? "Almost there - your custom size is still being prepared. Please click Add to cart again in a few seconds." : ("could not add to cart ("+(err&&err.message?err.message:err)+"). Please try again or contact us.")); });
      return;
    }

    if(needsServerPrice()){
      btn.disabled=true; btn.textContent="Pricing...";
      var reqBody={ handle:MATP.handle, lengthMm:parseFloat(state.size.length)||0, widthMm:parseFloat(state.size.width)||0, edging:(state.edgingLabel||"No"), fabric:(state.fabric||""), aluminium:(state.aluminium||"") };
      fetch(SERVICE_URL+"/custom-variant", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(reqBody) })
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
        .then(function(res){
          if(!res.ok || !res.j || !res.j.variantId){ throw new Error((res.j&&res.j.error)?(typeof res.j.error==="string"?res.j.error:JSON.stringify(res.j.error)):"pricing failed"); }
          props["_configured_price"]=res.j.price;
          btn.textContent="Adding...";
          return waitForSku(MATP.handle, res.j.variantId).then(function(ok){ if(!ok) throw new Error('VARIANT_NOT_READY'); return fetch("/cart/add.js", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ id:res.j.variantId, quantity:Math.max(1,state.qty||1), properties:props }) }); });
        })
        .then(function(r){ if(!r) return; if(!r.ok){ return r.json().then(function(j){ throw new Error(j.description||j.message||"add to cart failed"); }); } window.location.href="/cart"; })
        .catch(function(err){ btn.disabled=false; btn.textContent="Add to cart"; setErr((err&&err.message==='VARIANT_NOT_READY') ? "Almost there - your custom size is still being prepared. Please click Add to cart again in a few seconds." : ("could not add to cart ("+(err&&err.message?err.message:err)+"). Please try again or contact us.")); });
      return;
    }

    var form=getForm(); if(!form){ setErr("product form not found on page"); return; }
    if(state.variantId) setFormVariant(form, state.variantId);
    setFormQty(form, Math.max(1,state.qty||1));
    writeProps(form, props);
    var atc=form.querySelector('[data-product-atc]');
    btn.disabled=true; btn.textContent="Adding...";
    setTimeout(function(){ if(atc){ atc.click(); } else if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); } }, 60);
  }

  function wire(s){
    var back=ROOT.querySelector('[data-act=back]'), next=ROOT.querySelector('[data-act=next]');
    if(back) back.onclick=function(){ if(state.stepIndex>0){ state.stepIndex--; render(); } };
    if(next) next.onclick=function(){
      if(cfg.flow==="aam" && aamOutOfRange()){ openCustomSizeModal(); return; }
      if(cfg.flow==="aam" && step()==="review" && fabricOOS(state.fabric)){ openCustomSizeModal(); return; }
      var errs=validate();
      if(errs.length){ setErr(errs.join(" - ")); return; }
      if(step()==="review"){ addToCart(next); return; }
      if(cfg.lockToReview && step()==="size"){ var ri=cfg.steps.indexOf("review"); if(ri>-1){ state.stepIndex=ri; render(); return; } }
      state.stepIndex++; render();
    };
    var qi=ROOT.querySelector('#mc-qty');
    if(qi) qi.oninput=function(e){ var n=parseInt(e.target.value,10); state.qty=(isNaN(n)||n<1)?1:n; };
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-mcqty]'),function(b){
      b.onclick=function(){ state.qty=Math.max(1,(state.qty||1)+parseInt(b.getAttribute('data-mcqty'),10)); render(); };
    });
    Array.prototype.forEach.call(ROOT.querySelectorAll('.mc-steps .s'),function(chip){
      chip.onclick=function(){ var gi=parseInt(chip.getAttribute('data-go'),10); if(isNaN(gi)||gi===state.stepIndex) return; state.stepIndex=gi; render(); };
    });
    if(cfg.flow==="aam"){ wireAAM(s); return; }
    if(s==="size"){
      if(cfg.sizeMode==="variant"){
        var vs=ROOT.querySelector('#mc-variant-select');
        if(vs) vs.onchange=function(e){ var id=parseInt(e.target.value,10); if(!id){ state.variantId=null; state.variantTitle=""; state.variantPrice=0; render(); return; } state.variantId=id; var v=variants.filter(function(x){return x.id===id;})[0]; state.variantTitle=v?v.title:""; state.variantPrice=v?v.price:0; render(); };
      } else {
        var L=ROOT.querySelector('#mc-len'), W=ROOT.querySelector('#mc-wid');
        if(L) L.oninput=function(e){ state.size.length=e.target.value; render(); };
        if(W) W.oninput=function(e){ state.size.width=e.target.value; render(); };
        Array.prototype.forEach.call(ROOT.querySelectorAll('#mc-edging input'),function(r){ r.onchange=function(e){ state.edgingRate=parseFloat(e.target.getAttribute('data-rate')); state.edgingLabel=e.target.value; render(); }; });
      }
    }
    if(s==="options"){
      Array.prototype.forEach.call(ROOT.querySelectorAll('.mc-sw-wrap'),function(grp){
        var key=grp.getAttribute('data-key'), multi=grp.getAttribute('data-multi')==="true";
        Array.prototype.forEach.call(grp.querySelectorAll('.mc-sw'),function(sw){
          sw.onclick=function(){
            var val=sw.getAttribute('data-val');
            if(multi){ var arr=state.options[key]||[]; var ix=arr.indexOf(val); if(ix>-1) arr.splice(ix,1); else arr.push(val); state.options[key]=arr; }
            else state.options[key]=val;
            render();
          };
        });
      });
      Array.prototype.forEach.call(ROOT.querySelectorAll('select[data-key]'),function(sel){ sel.onchange=function(e){ state.options[e.target.getAttribute('data-key')]=e.target.value; }; });
      Array.prototype.forEach.call(ROOT.querySelectorAll('.mc-radios[data-key] input'),function(r){ r.onchange=function(e){ state.options[e.target.closest('.mc-radios').getAttribute('data-key')]=e.target.value; }; });
    }
  }
  function wireAAM(s){
    if(s==="size"){
      var L=ROOT.querySelector('#mc-len'), W=ROOT.querySelector('#mc-wid');
      if(L) L.oninput=function(e){ state.size.length=e.target.value; refreshAAMPrice(); updateOversize(); updateAAMDiagram(); };
      if(W) W.oninput=function(e){ state.size.width=e.target.value; refreshAAMPrice(); updateOversize(); updateAAMDiagram(); };
    }
    if(s==="aluminium"){ wireAAMSwatches(); }
    if(s==="fabric"){ wireAAMSwatches(); var cc=ROOT.querySelector('[data-cd-changecol]'); if(cc) cc.onclick=function(){ state.colourOpen=true; render(); }; }
    if(s==="review"){ var c=ROOT.querySelector('#mc-comments'); if(c) c.oninput=function(e){ state.comments=e.target.value; }; }
  }
  function wireAAMSwatches(){
    Array.prototype.forEach.call(ROOT.querySelectorAll('.mc-sw-wrap'),function(grp){
      var key=grp.getAttribute('data-key');
      Array.prototype.forEach.call(grp.querySelectorAll('.mc-sw'),function(sw){
        sw.onclick=function(){ applyAAMChoice(key, sw.getAttribute('data-val')); render(); };
      });
    });
  }
  function refreshAAMPrice(){ var el=ROOT.querySelector("#mc-price"); var p=computePrice(); tmgEmitUnit(p); if(el){ el.innerHTML=(p>0?money(p):"-"); } }
  // Orientation diagram follows the entered dimensions: portrait once it's deeper (F-to-B) than wide (L-to-R); landscape by default.
  function aamOrient(){ var L=parseFloat(state.size.length)||0, W=parseFloat(state.size.width)||0; return (L>0 && W>0 && W>L) ? 'portrait' : 'landscape'; }
  function aamDiagramSrc(){ return aamOrient()==='portrait' ? (cfg.sizeDiagramP||cfg.sizeDiagramL) : cfg.sizeDiagramL; }
  function updateAAMDiagram(){ var img=ROOT.querySelector('.mc-sizediagram'); if(img){ img.setAttribute('src', aamDiagramSrc()); } }

  /* --- Out-of-size -> custom-size quote request (ARCHIMAT/AAM only) --- */
  function aamOutOfRange(){
    if(cfg.flow!=="aam") return false;
    var z=cfg.size, L=parseFloat(state.size.length), W=parseFloat(state.size.width);
    if(!(L>0) || !(W>0)) return false; // wait until BOTH dimensions are entered, so the quote shows the full size
    return L<z.lengthMin || L>z.lengthMax || W<z.widthMin || W>z.widthMax;
  }
  function quoteSizeText(){
    var z=cfg.size, parts=[];
    if(state.size.length) parts.push(state.size.length+z.unit+" (L)");
    if(state.size.width) parts.push(state.size.width+z.unit+" (W)");
    var s=parts.join(" x ");
    if(state.recessDepth>0) s+=(s?", ":"")+"recess "+state.recessDepth+z.unit;
    return s;
  }
  function updateOversize(){
    var nx=ROOT.querySelector('[data-act=next]'); if(!nx) return;
    if(step()==="size") nx.innerHTML = aamOutOfRange() ? "Request a custom size" : "Next &rsaquo;";
  }
  function prefillQuoteForm(formArg){
    var root = (formArg && formArg.jquery) ? formArg[0] : ((formArg && formArg.nodeType) ? formArg : document.querySelector('#mc-hsform form'));
    if(!root) return;
    var insertTxt = state.fabric ? (state.fabric+(state.fabricColour?(" "+state.fabricColour):"")+(state.aluminium?(" / "+state.aluminium+" aluminium"):"")) : "";
    var prodName = ((AAM_SYNC.quoteForm ? aamDisplayTitle() : "")||MATP.title||"") + (insertTxt?(" - "+insertTxt):"");
    var vals = { name_of_product:prodName, mat_size:quoteSizeText(), quantity:String(Math.max(1,state.qty||1)) };
    Object.keys(vals).forEach(function(name){
      if(!vals[name]) return;
      var el=root.querySelector('[name="'+name+'"]');
      if(el && !el.value){ el.value=vals[name]; el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true})); }
    });
  }
  function openCustomSizeModal(){
    var ov=document.createElement('div'); ov.className='mc-modal';
    ov.innerHTML='<div class="mc-modal-box"><button type="button" class="mc-modal-x" aria-label="Close">&times;</button>'+
      '<h3>Request a custom size</h3>'+
      '<div id="mc-hsform"></div></div>';
    document.body.appendChild(ov);
    document.documentElement.style.overflow='hidden';
    function close(){ ov.remove(); document.documentElement.style.overflow=''; }
    ov.addEventListener('click',function(e){ if(e.target===ov||e.target.classList.contains('mc-modal-x')) close(); });
    function build(){ if(window.hbspt&&window.hbspt.forms){ window.hbspt.forms.create({ portalId:HS_QUOTE.portalId, formId:HS_QUOTE.formId, region:HS_QUOTE.region, target:"#mc-hsform", onFormReady:prefillQuoteForm }); } }
    if(window.hbspt&&window.hbspt.forms){ build(); }
    else { var sc=document.createElement('script'); sc.src=HS_QUOTE.script; sc.charset='utf-8'; sc.onload=build; document.body.appendChild(sc); }
  }

  placeConfigurator();
  hideThemeControls();
  captureProductIdentity();
  render();
})();
